// extracted by mini-css-extract-plugin
export var copy_button = "FontFamily-module--copy_button--brNhb";
export var copy_button_container = "FontFamily-module--copy_button_container--Ezeyv";
export var custom_snippet = "FontFamily-module--custom_snippet--zdQ5M";